import angular from 'angular';

angular.module('cloudX').factory('checkInvoiceTeamAccess', [
  'authService',
  function(authService, featureflags) {
    return function(relationTeamAccessCode) {
      var auth = authService.getClaims();
      if (!auth) return false;
      if (auth.su) return true;
      const relationTeamCode = BigInt(relationTeamAccessCode);
      if (relationTeamCode === 0n) return true;
      const userInvoiceTeamCode = BigInt(auth.isc);
      // eslint-disable-next-line no-bitwise
      return (userInvoiceTeamCode & relationTeamCode) > 0n;
    };
  },
]);
